import React, { Suspense } from 'react';
import { MapIcon, PenToolIcon, UsersIcon, CheckSquareIcon } from 'lucide-react';
import { Tab } from './types';
export const quizSteps = [{
  question: 'What kind of story are you telling?',
  key: 'tone',
  options: ['Character-driven and emotional', 'Fast-paced and plot-focused', 'Dark, gritty, or morally grey storylines', 'Light-hearted and fun', 'Deep and thought-provoking']
}, {
  question: 'Which setting fits your story best?',
  key: 'setting',
  options: ['A realistic, modern-day world', 'A historical time period', 'A futuristic or science-fiction setting', 'A magical or fantastical world', 'A small town or domestic environment']
}, {
  question: 'What is your central theme or core element?',
  key: 'theme',
  options: ['Love and relationships', 'Mystery and discovery', 'Survival or war', 'Coming-of-age or identity', 'Power, betrayal, or revenge themes', 'Found family or belonging']
}, {
  question: "How would you describe your story's tone?",
  key: 'emotion',
  options: ['Dark and intense', 'Wholesome and heartfelt', 'Suspenseful or thrilling', 'Witty and humorous', 'Slow and atmospheric']
}, {
  question: 'Any specific tropes you already have in mind?',
  key: 'tropes',
  options: ['Enemies to lovers', 'Found family', 'Secret royalty', 'Morally grey hero', 'Second chance romance', 'Grumpy/sunshine', 'Chosen one', 'Fake dating', 'Slow burn romance'],
  multi: true
}];
export const tabs: Tab[] = [{
  id: 'roadmap',
  label: 'Roadmap',
  icon: <MapIcon className="h-5 w-5" data-id="element-15232" data-mp="uh96v9gcdh8s" />
}, {
  id: 'tools',
  label: 'Tools & Software',
  icon: <PenToolIcon className="h-5 w-5" data-id="element-15233" data-mp="qjbgi3au4p3t" />
}, {
  id: 'vendors',
  label: 'Vendor Directory',
  icon: <UsersIcon className="h-5 w-5" data-id="element-15234" data-mp="butacm5yzrpf" />
}, {
  id: 'checklist',
  label: 'Checklist',
  icon: <CheckSquareIcon className="h-5 w-5" data-id="element-15235" data-mp="fweumsku389n" />
}];